import { ValidSkusItem } from '@/src/types/common/stock';
import { generateValidSkuSetItem } from '../StockProductSelection/tools';

/**
 * 将验证后的导入数据转换为产品列表项
 * @param items 校验后的导入项
 * @param pasrsedSkuMap sku item映射表，sku -> 导入的sku信息
 * @returns
 */
export const transformToProductItems = (
  items: ValidSkusItem[],
  pasrsedSkuMap: Record<string, any>,
) => {
  return items.map((item) => {
    const parsedSkuItem = pasrsedSkuMap[item.sku] || { quantity: 0, notes: '' };

    // 使用已有的产品生成函数创建产品项
    const productItem = generateValidSkuSetItem(item);

    // 添加数量和备注
    return {
      ...productItem,
      quantity: parsedSkuItem.quantity || 0,
      notes: parsedSkuItem.notes || '',
    };
  });
};
